export const dialogStyles = {
	paperProps: {
		style: {
			height: '648px',
			width: '736px',
			maxHeight: 'unset',
			maxWidth: 'unset',
			borderRadius: '8px',
			boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.25)',
			'.dialog-title h2': {
				display: 'flex',
			},
		},
	},
	backDropProps: {
		style: {
			backgroundColor: 'rgba(255, 255, 255, 0.92)',
			opacity: '0.7',
		},
	},
	title: {
		padding: 0,
		'& .dialog-title h2': {
			display: 'flex !important',
		},
	},
	icon: {
		position: 'absolute',
		right: 8,
		top: 8,
		color: (theme) => theme.palette.grey[500],
	},
	iconColor: {
		color: '#5F6367',
	},
	actions: { marginBottom: 16, marginRight: 16 },
	content: {
		padding: '8px 16px',
	},
};
